import { Alert } from '@mui/material';
import { env } from '@/lib/env';
import { useDevPaymentMode } from './paymentService';

/** Always-visible reminder that payments are simulated (never shown in production builds). */
export function DevModeBanner() {
  const { data: devMode } = useDevPaymentMode();
  if (env.isProduction || !devMode) return null;
  return (
    <Alert severity="warning" variant="outlined" sx={{ borderRadius: 0, borderLeft: 0, borderRight: 0, borderTop: 0, py: 0 }}>
      Development payment mode — purchases and payouts are simulated. No real money moves.
    </Alert>
  );
}
